/* Floating buy bar behaviour (mobile only), aligned with the ASHEIS storefront.
 *
 * The bar is visible from page load via CSS; this script fades it out as the
 * product section scrolls away, so it stops covering content once the shopper
 * has moved past the product itself.
 *
 * The fade is anchored to the BOTTOM of .shopify-section--main-product rather
 * than to the top of the following section. The following section is often
 * populated by other scripts (recently viewed products reads localStorage,
 * related products fetches recommendations), so at DOMContentLoaded it can
 * still have no layout at all — getBoundingClientRect() then returns zeros,
 * which read as "already scrolled past" and left the bar stuck at opacity 0.
 * The main product section always has layout, so it cannot mis-measure.
 */
(function () {
  function init() {
    var bar = document.querySelector('.product-sticky-bar');
    var main = document.querySelector('.shopify-section--main-product');
    if (!bar || !main) return;

    var mqMobile = window.matchMedia('(max-width: 699px)');

    function update() {
      // Only the mobile floating bar fades; >=700px keeps the stock behaviour.
      if (!mqMobile.matches) {
        bar.style.removeProperty('opacity');
        bar.style.removeProperty('pointer-events');
        return;
      }

      var rect = main.getBoundingClientRect();

      // Defensive: if the section somehow has no layout yet, leave the bar
      // visible rather than guessing it has been scrolled past.
      if (rect.width === 0 && rect.height === 0) {
        bar.style.opacity = '1';
        bar.style.pointerEvents = 'auto';
        return;
      }

      // rect.bottom shrinks as the product scrolls away. Stay fully visible
      // while the product still fills the lower half of the screen, then fade
      // to zero as its bottom edge reaches the top of the viewport.
      var fadeStart = window.innerHeight / 2;
      var opacity;
      if (rect.bottom >= fadeStart) opacity = 1;
      else if (rect.bottom <= 0) opacity = 0;
      else opacity = rect.bottom / fadeStart;

      bar.style.opacity = opacity.toFixed(3);
      bar.style.pointerEvents = opacity < 0.05 ? 'none' : 'auto';
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Images and app-injected sections change the layout after DOMContentLoaded,
    // so recompute once everything has settled instead of trusting the first pass.
    window.addEventListener('load', onScroll);
    if (window.ResizeObserver) new ResizeObserver(onScroll).observe(main);

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
